import useTabs from '@/hooks/useTabs'
import { Tabs } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'
import SurveyList from './Survey/List'
import QuarterlyReport from './QuarterlyReport'
import SubHeaders from '@/components/Headers/SubHeaders'
import { paths } from '@/utils/path'

const SurveyHome = () => {
    const { t } = useTranslation('surveys')

    const { TabComponent, TabProps } = useTabs({
        tabs: [
            {
                label: t('surveys.tab.quarterly_report'),
                value: 'quarterly-report',
                component: <QuarterlyReport />,
            },
            {
                label: t('surveys.tab.list'),
                value: 'surveys',
                component: <SurveyList />,
            },
        ],
    })
    return (
        <>
            <SubHeaders
                breadcrumbs={[
                    { title: t('surveys.title'), path: paths.surveys },
                ]}
            />
            <Tabs {...TabProps} />
            {TabComponent}
        </>
    )
}

export default SurveyHome
